export default __webpack_public_path__ + "static/media/ruler.710f5961.svg";